import { Twitch, Youtube, Instagram, Facebook, Mail } from "lucide-react";

// Update this address to your real contact email (or tell the keeper to set it).
const CONTACT_EMAIL = "nocturneorchid@gmail.com";

const RAVENS = [
  { name:"Twitch", handle:"orchidnocturne", url:"https://www.twitch.tv/orchidnocturne", icon: Twitch, note:"Where the streams happen." },
  { name:"YouTube", handle:"@NocturneOrchid", url:"https://www.youtube.com/@NocturneOrchid", icon: Youtube, note:"VODs, highlights, occasional essays." },
  { name:"Instagram", handle:"@nocturneorchid", url:"https://www.instagram.com/nocturneorchid/", icon: Instagram, note:"Photos, moods, orchids." },
  { name:"Facebook", handle:"Nocturne Orchid", url:"https://www.facebook.com/profile.php?id=61591214425413", icon: Facebook, note:"For the folks who linger on FB." },
];

export default function MessengerRavens() {
  return (
    <div className="page-container fade-in" data-testid="ravens-page">
      <div className="page-eyebrow">socials & contact</div>
      <h1 className="page-title">Messenger Ravens</h1>
      <p className="page-sub">Small black birds carrying small black letters between worlds. Send one, or follow where they fly.</p>

      <div className="bento-grid mt-10">
        {RAVENS.map((r,i) => (
          <a key={r.name} href={r.url} target="_blank" rel="noreferrer" className="room-card p-6 group" data-testid={`raven-${r.name.toLowerCase()}`}>
            <span className="ornate-corner tl" /><span className="ornate-corner tr" />
            <span className="ornate-corner bl" /><span className="ornate-corner br" />
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 grid place-items-center rounded border" style={{borderColor:"var(--gold)", background:"rgba(0,0,0,0.25)"}}>
                <r.icon className="h-5 w-5" style={{color:"var(--gold)"}} />
              </div>
              <div>
                <div className="tavern-heading text-xl gold-text">{r.name}</div>
                <div className="text-xs" style={{color:"var(--orchid-light)"}}>{r.handle}</div>
              </div>
            </div>
            <p className="text-sm mt-4" style={{color:"var(--muted)"}}>{r.note}</p>
            <div className="tavern-script text-lg mt-3 group-hover:translate-x-1 transition-transform" style={{color:"var(--orchid-light)"}}>send the raven →</div>
          </a>
        ))}

        <a
          href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("A raven for the tavern keeper")}`}
          className="room-card p-6 group"
          data-testid="raven-email"
        >
          <span className="ornate-corner tl" /><span className="ornate-corner tr" />
          <span className="ornate-corner bl" /><span className="ornate-corner br" />
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 grid place-items-center rounded border" style={{borderColor:"var(--gold)", background:"rgba(0,0,0,0.25)"}}>
              <Mail className="h-5 w-5" style={{color:"var(--gold)"}} />
            </div>
            <div>
              <div className="tavern-heading text-xl gold-text">Email</div>
              <div className="text-xs" style={{color:"var(--orchid-light)"}}>{CONTACT_EMAIL}</div>
            </div>
          </div>
          <p className="text-sm mt-4" style={{color:"var(--muted)"}}>
            For collaborations, questions, or a quiet word — send a letter straight to the keeper's desk.
          </p>
          <div className="tavern-script text-lg mt-3 group-hover:translate-x-1 transition-transform" style={{color:"var(--orchid-light)"}}>send a raven →</div>
        </a>

        <div className="room-card p-6" data-testid="raven-announcements">
          <Mail className="h-6 w-6" style={{color:"var(--gold)"}}/>
          <div className="tavern-heading text-xl gold-text mt-2">Community Announcements</div>
          <p className="text-sm mt-2" style={{color:"var(--muted)"}}>
            Big news, schedule changes and seasonal events are pinned to the Notice Board.
            Subscribe to the streams to catch them live.
          </p>
        </div>
      </div>
    </div>
  );
}
